import React, {Fragment} from 'react'
import Dropzone from "react-dropzone";
import {Card, Col, Row, Button} from "reactstrap";
import {Link} from "react-router-dom";
import {faTrashAlt} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {_delete} from "../Api";
import {imgPath} from "../Helpers";



class FormUploadFiles extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedFiles: []
        }

        this.handleImageDelete = this.handleImageDelete.bind(this);
        this.handleAcceptedFiles = this.handleAcceptedFiles.bind(this);
    }
    handleImageDelete () {
        _delete(this.props.db + "/" + this.props.item, this.props.name).then(res => {

        })
    }

    handleAcceptedFiles(files) {
        files.map((file) =>
            Object.assign(file, {
                preview: URL.createObjectURL(file),
                formattedSize: this.formatBytes(file.size),
                fieldName: this.props.name
            })
        );
        this.setState({selectedFiles: files}, () => {
            this.props.upload(files);
            this.props.onChange(this.state.selectedFiles);
        });
    }

    formatBytes(bytes, decimals = 2) {
        if (bytes === 0) return "0 Bytes";
        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
    }

    render() {
        return (
            <Fragment>

                <Dropzone onDrop={(acceptedFiles) => {
                    this.handleAcceptedFiles(acceptedFiles); }}>
                    {({getRootProps, getInputProps}) => (
                        <div className="dropzone">
                            <div className="dz-message needsclick mt-2"
                                 {...getRootProps()} >
                                <input {...getInputProps()} />
                                <div className="mb-3"><i className="display-4 text-muted bx bxs-cloud-upload"/></div>
                                <h4>Drop files here or click to upload.</h4>
                            </div>
                        </div>
                    )}
                </Dropzone>

                {this.props.defaultValue &&
                <div className="dropzone-previews mt-3 mb-3" id="file-previews">
                    {[this.props.defaultValue].map((f, i) => {

                        return (
                            <Card
                                className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                key={i + "-file"}>
                                <div className="p-2">
                                    <Row className="align-items-center">
                                        <Col className="col-auto">
                                            <img data-dz-thumbnail="" height="80"
                                                 className="avatar-sm rounded bg-light"
                                                 alt=" "  src={imgPath(f)} />
                                        </Col>
                                        <Col className="col-3 align-content-end">

                                            <Button outline color="danger" className="waves-effect waves-light btn-sm"
                                                    onClick={this.handleImageDelete}>
                                                <FontAwesomeIcon icon={faTrashAlt}/> Delete
                                            </Button>
                                        </Col>
                                    </Row>
                                </div>
                            </Card>
                        );
                    })}
                </div>
                }


                <div className="dropzone-previews mt-3" id="file-previews">
                    {this.state.selectedFiles.map((f, i) => {
                        return (
                            <Card
                                className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                key={i + "-file"}>
                                <div className="p-2">
                                    <Row className="align-items-center">
                                        <Col className="col-auto">
                                            <img data-dz-thumbnail=""
                                                 height="80"
                                                 className="avatar-sm rounded bg-light"
                                                 alt={f.name}
                                                 src={f.preview}/>
                                        </Col>
                                        <Col>
                                            <Link to="#" className="text-muted font-weight-bold">{f.name}</Link>
                                            <p className="mb-0"><strong>{f.formattedSize}</strong></p>
                                        </Col>
                                    </Row>
                                </div>
                            </Card>
                        );
                    })}
                </div>
            </Fragment>
        )
    }
}

export default FormUploadFiles;